// extracted by mini-css-extract-plugin
module.exports = {"goalReportSnippet":"style_goalReportSnippet__1zFeX","info":"style_info__19--e","unread":"style_unread__3pXgN"};